module.exports = __webpack_public_path__ + "img/step-seven-icon.a6e6bf05.jpg";